<template>
  <div>
    <v-tabs color="realEstate" v-model="tab">
      <v-tab @click="fetchPending">
        {{ $t('hausefulInvoices.pending') }}
      </v-tab>
      <v-tab @click="fetchSent">
        {{ $t('hausefulInvoices.sent') }}
      </v-tab >
      <div v-if="tab === 0" class="tabs__filters">
        <HausefulInvoiceListFilters />
      </div>
      <div v-if="tab === 1" class="tabs__filters">
        <HausefulTakeRateInvoicesFilters />
      </div>
    </v-tabs>

    <v-card outlined>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <HausefulInvoiceList />
        </v-tab-item>
        <v-tab-item>
          <HausefulTakeRateInvoicesList />
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <ModalHausefulTakeRateInvoiceShow />
    <ModalHausefulTakeRateInvoiceDelete />
    <ModalHausefulTakeRateInvoiceUpload />
    <ModalHausefulInvoiceGenerateAsaas />
    <ModalHausefulInvoiceGenerateAsaasBatch />
    <ModalHausefulInvoiceLinkPayments />
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

import HausefulInvoiceList from './components/HausefulInvoiceList'
import HausefulInvoiceListFilters from './components/HausefulInvoiceListFilters'
import HausefulTakeRateInvoicesList from './components/HausefulTakeRateInvoicesList'
import HausefulTakeRateInvoicesFilters from './components/HausefulTakeRateInvoicesFilters'
import ModalHausefulTakeRateInvoiceShow from './components/modals/ModalHausefulTakeRateInvoiceShow'
import ModalHausefulTakeRateInvoiceDelete from './components/modals/ModalHausefulTakeRateInvoiceDelete'
import ModalHausefulTakeRateInvoiceUpload from './components/modals/ModalHausefulTakeRateInvoiceUpload'
import ModalHausefulInvoiceGenerateAsaas from './components/modals/ModalHausefulInvoiceGenerateAsaas'
import ModalHausefulInvoiceGenerateAsaasBatch from './components/modals/ModalHausefulInvoiceGenerateAsaasBatch'
import ModalHausefulInvoiceLinkPayments from './components/modals/ModalHausefulInvoiceLinkPayments'

export default {
  name: 'HausefulInvoices',

  components: {
    HausefulInvoiceList,
    HausefulInvoiceListFilters,
    HausefulTakeRateInvoicesList,
    HausefulTakeRateInvoicesFilters,
    ModalHausefulTakeRateInvoiceShow,
    ModalHausefulTakeRateInvoiceDelete,
    ModalHausefulTakeRateInvoiceUpload,
    ModalHausefulInvoiceGenerateAsaas,
    ModalHausefulInvoiceGenerateAsaasBatch,
    ModalHausefulInvoiceLinkPayments,
  },

  methods: {
    ...mapActions(['fetchHausefulInvoices', 'fetchHausefulTakeRateInvoices']),
    ...mapMutations(['setFilters', 'setIsDrawerOpen', 'setCurrentPage', 'setTotalPages', 'setHausefulInvoices', 'setHausefulTakeRateInvoices']),

    resetInvoicesListAndFilters() {
      this.setFilters({})
      this.setTotalPages(0)
      this.setCurrentPage(1)
      this.setHausefulInvoices([])
      this.setHausefulTakeRateInvoices([])
    },

    fetchPending() {
      this.resetInvoicesListAndFilters()
      this.$nextTick(() => this.fetchHausefulInvoices())
    },

    fetchSent() {
      this.resetInvoicesListAndFilters()
      this.$nextTick(() => this.fetchHausefulTakeRateInvoices())
    },
  },

  data() {
    return {
      tab: 0,
      hover: false,
      loading: false,
    }
  },
}
</script>
